var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.166 5.667a.834.834 0 0 1 1.667 0v4.167a.834.834 0 0 1-1.667 0V5.667Zm0 6.667a.834.834 0 1 1 1.668 0 .834.834 0 0 1-1.668 0ZM9 15.667A6.674 6.674 0 0 1 2.333 9 6.674 6.674 0 0 1 9 2.334 6.674 6.674 0 0 1 15.666 9 6.674 6.674 0 0 1 9 15.667Zm0-15a8.333 8.333 0 1 0 0 16.667A8.333 8.333 0 1 0 9 .667Z",
    fill: "#D23B12"
  })));
};
export default SvgError;